// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Outlook = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Outlook = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Outlook = _exports.Outlook = function Outlook(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14329)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M19.9991 9.97494C20.0002 9.81523 19.9194 9.66658 19.7861 9.58307H19.7838L19.7754 9.57832L12.8451 5.38882C12.8152 5.36817 12.7842 5.3493 12.7521 5.3323C12.4845 5.19132 12.1667 5.19132 11.8991 5.3323C11.867 5.34931 11.836 5.36817 11.8061 5.38882L4.87586 9.57832L4.86749 9.58307C4.65568 9.71758 4.59075 10.002 4.72246 10.2183C4.76127 10.282 4.81473 10.3351 4.87818 10.373L11.8084 14.5625C11.8384 14.583 11.8695 14.6018 11.9014 14.619C12.169 14.76 12.4869 14.76 12.7545 14.619C12.7864 14.6018 12.8175 14.583 12.8475 14.5625L19.7777 10.373C19.9162 10.2906 20.0007 10.1386 19.9991 9.97494Z",
      fill: "#0A2767"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.68551 7.17772H10.2334V11.4351H5.68551V7.17772ZM19.0706 2.85V0.902495C19.0815 0.415575 18.7042 0.0116677 18.2274 0H6.42552C5.94873 0.0116677 5.57134 0.415575 5.58226 0.902495V2.85L12.559 4.74999L19.0706 2.85Z",
      fill: "#0364B8"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.58203 2.84961H10.2332V7.12461H5.58203V2.84961Z",
      fill: "#0078D4"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.8836 2.84961H10.2324V7.12461L14.8836 11.3996H19.0696V7.12461L14.8836 2.84961Z",
      fill: "#28A8EA"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.2324 7.125H14.8836V11.4H10.2324V7.125Z",
      fill: "#0078D4"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.2324 11.4004H14.8836V15.6754H10.2324V11.4004Z",
      fill: "#0364B8"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.68359 11.4355H10.2315V15.3058H5.68359V11.4355Z",
      fill: "#14447D"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.8828 11.4004H19.0689V15.6754H14.8828V11.4004Z",
      fill: "#0078D4"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M19.7881 10.3465L19.7793 10.3513L12.8491 14.3318C12.8188 14.3508 12.7882 14.3688 12.7561 14.385C12.6383 14.4422 12.5105 14.4745 12.3802 14.48L12.0016 14.2539C11.9696 14.2375 11.9386 14.2192 11.9086 14.1993L4.88536 10.1057H4.88211L4.65234 9.97461V18.0325C4.65593 18.5701 5.08545 19.003 5.61187 18.9996H19.0565C19.0644 18.9996 19.0714 18.9958 19.0798 18.9958C19.191 18.9885 19.3006 18.9652 19.4053 18.9265C19.4506 18.9069 19.4943 18.8837 19.536 18.8571C19.5672 18.8391 19.6207 18.7996 19.6207 18.7996C19.859 18.6196 20 18.3352 20.0012 18.0325V9.97461C20.001 10.1287 19.9196 10.2708 19.7881 10.3465Z",
      fill: "url(#paint0_linear_49_14329)"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.5",
      d: "M19.6293 9.94257V10.4366L12.3828 15.5319L4.88052 10.1088C4.88052 10.1062 4.87843 10.1041 4.87587 10.1041L4.1875 9.68132V9.32506L4.47122 9.32031L5.07122 9.67182L5.08516 9.67657L5.13633 9.70982C5.13633 9.70982 12.1875 13.8186 12.2061 13.8281L12.4759 13.9896C12.4991 13.9801 12.5224 13.9706 12.5503 13.9611C12.5642 13.9516 19.5503 9.93781 19.5503 9.93781L19.6293 9.94257Z",
      fill: "#0A2767"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M19.7881 10.3465L19.7793 10.3518L12.8491 14.3323C12.8188 14.3512 12.7881 14.3693 12.756 14.3854C12.4869 14.5197 12.1722 14.5197 11.903 14.3854C11.8711 14.3693 11.8401 14.3516 11.81 14.3323L4.87978 10.3518L4.87142 10.3465C4.73762 10.2724 4.65373 10.13 4.65234 9.97461V18.0325C4.65568 18.57 5.08505 19.003 5.61137 18.9996C5.61137 18.9996 5.61139 18.9996 5.61141 18.9996H19.0421C19.5684 19.003 19.9978 18.5701 20.0012 18.0325C20.0012 18.0325 20.0012 18.0325 20.0012 18.0325V9.97461C20.001 10.1287 19.9196 10.2708 19.7881 10.3465Z",
      fill: "#1490DF"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.1",
      d: "M12.949 14.2734L12.8453 14.3328C12.8153 14.3524 12.7842 14.3703 12.7523 14.3865C12.638 14.4438 12.5138 14.4774 12.3867 14.4853L15.0235 17.6697L19.623 18.8016C19.749 18.7044 19.8493 18.5765 19.9146 18.4297L12.949 14.2734Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.05",
      d: "M13.4188 14.0039L12.8453 14.3331C12.8153 14.3526 12.7842 14.3705 12.7523 14.3868C12.638 14.444 12.5138 14.4776 12.3867 14.4855L13.6221 17.964L19.6244 18.8004C19.8608 18.6191 20.0001 18.3348 20.0002 18.0328V17.9288L13.4188 14.0039Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.62443 18.9996H19.0407C19.2471 19.0007 19.4485 18.9341 19.6151 18.8096L12.0012 14.2548C11.9692 14.2384 11.9381 14.2202 11.9081 14.2002L4.88489 10.1067H4.88164L4.65234 9.97461V18.005C4.65182 18.5538 5.08704 18.9991 5.62443 18.9996Z",
      fill: "#28A8EA"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.1",
      d: "M11.164 4.67145V14.8032C11.1631 15.1584 10.9516 15.4777 10.6291 15.6107C10.5292 15.6545 10.4216 15.6772 10.3128 15.6772H4.65234V4.27578H5.58258V3.80078H10.3128C10.7827 3.8026 11.163 4.19158 11.164 4.67145Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.2",
      d: "M10.6989 5.1461V15.2778C10.7 15.3926 10.6762 15.5062 10.6291 15.6103C10.4999 15.9355 10.1913 16.1488 9.84769 16.1504H4.65234V4.27543H9.84769C9.98265 4.27405 10.1157 4.30843 10.2337 4.37519C10.5189 4.52188 10.6987 4.82006 10.6989 5.1461Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.2",
      d: "M10.6989 5.1461V14.3278C10.6966 14.8075 10.3174 15.1963 9.8477 15.2004H4.65234V4.27543H9.84769C9.98265 4.27405 10.1157 4.30843 10.2337 4.37519C10.5189 4.52188 10.6987 4.82006 10.6989 5.1461Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.2",
      d: "M10.2337 5.14606V14.3278C10.2332 14.8082 9.85297 15.198 9.38258 15.2004H4.65234V4.27539H9.38257C9.85291 4.27565 10.234 4.66525 10.2337 5.14559C10.2337 5.14575 10.2337 5.14591 10.2337 5.14606Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M0.852555 4.27539H9.37999C9.85085 4.27539 10.2325 4.66521 10.2325 5.14606V13.8547C10.2325 14.3356 9.85085 14.7254 9.37999 14.7254H0.852555C0.381697 14.7254 0 14.3356 0 13.8547V5.14606C0 4.66521 0.381708 4.27539 0.852555 4.27539Z",
      fill: "url(#paint1_linear_49_14329)"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.66328 7.92771C2.87341 7.4705 3.21257 7.08789 3.63724 6.82904C4.10753 6.55407 4.64299 6.41699 5.18468 6.43288C5.68673 6.42176 6.18213 6.55173 6.61677 6.8086C7.02543 7.05748 7.35455 7.42215 7.56421 7.85835C7.79253 8.339 7.90633 8.86797 7.89631 9.4021C7.90737 9.96031 7.7903 10.5134 7.55445 11.0171C7.3398 11.4689 7.00023 11.8465 6.5777 12.1034C6.12631 12.3682 5.61252 12.5015 5.09212 12.4891C4.57935 12.5018 4.07302 12.3703 3.6284 12.1091C3.21621 11.8599 2.88295 11.4948 2.6684 11.0575C2.43873 10.5838 2.32358 10.0607 2.33259 9.53224C2.32302 8.97878 2.43607 8.43028 2.66328 7.92771ZM3.70142 10.5069C3.81345 10.796 4.00344 11.0467 4.24932 11.2299C4.49978 11.4087 4.79968 11.5009 5.10513 11.493C5.43044 11.5062 5.75109 11.4108 6.01863 11.2213C6.2614 11.0387 6.44639 10.7873 6.55071 10.4984C6.66733 10.1757 6.72488 9.83389 6.72048 9.48998C6.72409 9.14277 6.66999 8.79745 6.56048 8.46873C6.46376 8.17194 6.28473 7.91023 6.04513 7.71538C5.7843 7.51694 5.46452 7.41629 5.13955 7.43038C4.82747 7.42213 4.52086 7.51508 4.26374 7.6959C4.01369 7.87991 3.8201 8.13281 3.7056 8.42502C3.4516 9.09485 3.45028 9.83714 3.70188 10.5079L3.70142 10.5069Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.8828 2.84961H19.0689V7.12461H14.8828V2.84961Z",
      fill: "#50D9FF"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
      id: "paint0_linear_49_14329",
      x1: "12.3268",
      y1: "9.97461",
      x2: "12.3268",
      y2: "18.9996",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      "stop-color": "#35B8F1"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "1",
      "stop-color": "#28A8EA"
    })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
      id: "paint1_linear_49_14329",
      x1: "1.7776",
      y1: "3.59506",
      x2: "8.66776",
      y2: "15.2802",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      "stop-color": "#1784D9"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "0.5",
      "stop-color": "#107AD5"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "1",
      "stop-color": "#0A63C9"
    })), /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14329"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "white"
    }))));
  };
});
